import {KeyLabel} from './key-label.model';
export enum DomainActivityStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export const DomainActivityStatusLabels = {
  PENDING: 'Pending',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};

export const DomainActivityStatusKL = () =>
  (Object.keys(DomainActivityStatusLabels).map(key => new KeyLabel<DomainActivityStatus>(<DomainActivityStatus>key, DomainActivityStatusLabels[key])));

